import {Administration} from './administration';

export class User {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  active: boolean;
  administrations: Administration[];
}
